import { NULL } from "constants/primitives";
import getLocalStorage from "./getLocalStorage";
import report from "./report";

function getLocalStorageItem<Value, Fallback>(
  key: string,
  fallback: Fallback
): Value | Fallback {
  const storage = getLocalStorage();
  try {
    if (!storage) {
      return fallback;
    }
    const value = storage.getItem(key);
    if (value === NULL) {
      return fallback;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      report(e);
      return fallback;
    }
  } catch (e) {
    report(e);
    return fallback;
  }
}

export default getLocalStorageItem;
